import {ChangeDetectionStrategy, Component, inject, OnInit} from '@angular/core';

import {MainLayoutComponent} from './layout/main-layout/main-layout.component';
import {AlertComponent} from './core/alert/alert.component';
import {AuthService} from "./core/auth/auth.service";
import {ToastComponent} from "./shared/component/app-toasts/toast.component";

@Component({
  selector: 'green-x-root',
  imports: [MainLayoutComponent, AlertComponent, ToastComponent],
  template: `
    <green-x-alert></green-x-alert>
    <green-x-main-layout/>
    <green-x-toast></green-x-toast>`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent implements OnInit {

  private authService = inject(AuthService);

  async ngOnInit() {
    await this.authService.initAuth();
    // Now you can safely check authentication status
  }
}
